// extracted by mini-css-extract-plugin
export default {"projectsList":"ProjectsList_projectsList__TBMmq"};